export const isDevEnv = window.env.ENVIRONMENT === 'development';
export const isTestEnv = window.env.ENVIRONMENT === 'client-t';
export const isProdEnv = window.env.ENVIRONMENT === 'production';
